import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyAddChannel = lazy(() => import('./AddChannel'));

export const AddChannel: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyAddChannel {...props} />
	</Suspense>
);
